import { Button } from 'shared-ui';

interface AuthErrorViewProps {
    message: string;
    onRetry: () => void;
}

/**
 * Displayed when MSAL initialisation fails or a fatal auth error occurs.
 * Presents a user-friendly message and a retry action.
 */
export function AuthErrorView({ message, onRetry }: AuthErrorViewProps) {
    return (
        <div className="bg-background flex min-h-screen items-center justify-center p-6">
            <div className="max-w-md space-y-6 text-center">
                <div className="space-y-2">
                    <h1 className="text-2xl font-extrabold tracking-wide uppercase">Sign In Error</h1>
                    <p className="text-muted-foreground text-sm">{message}</p>
                </div>
                <Button onClick={onRetry} className="w-full">
                    Try Again
                </Button>
            </div>
        </div>
    );
}
